<template>
  <main
    class="mx-4 lg:mx-40 py-14 md:py-28 lg:py-24 text-primar-500"
  >
    <div>
      <h2
        class="text-primar-400 text-3xl lg:text-4xl lg:leading-10 font-extrabold"
      >
        {{ $t("navHeader.legal.privacy")}}
      </h2><br/><br/>
	  <p>{{ $t("privacy.title")}}</p>
	<p>{{ $t("privacy.subtitle")}}</p>
	<br/><br/>
	<h2 class="text-primar-400 text-3xl lg:text-4xl lg:leading-10 font-extrabold">{{ $t("privacy.titleOne")}}</h2>
	<br/><br/>
	<p>{{ $t("privacy.textOneTwo")}}</p>
	<p>{{ $t("privacy.textOneTree")}}</p>
	<p>{{ $t("privacy.textOneFour")}}</p>
	<p>{{ $t("privacy.textOneFive")}}</p>
	<p>{{ $t("privacy.textOneSix")}}</p>
	<p>{{ $t("privacy.textOneSeven")}}</p>
	<p>{{ $t("privacy.textOneEight")}}</p>
	<p>{{ $t("privacy.textOneNine")}}</p>
	<p>{{ $t("privacy.textOneTen")}}</p>
	<p>{{ $t("privacy.textOneEleven")}}</p>
	<p>{{ $t("privacy.textOneTwelve")}}</p>
	<p>{{ $t("privacy.textOneThridteen")}}</p>
	<p>{{ $t("privacy.textOneFourteen")}}</p>
	<br/><br/>
	<h2 class="text-primar-400 text-3xl lg:text-4xl lg:leading-10 font-extrabold">{{ $t("privacy.titleTwo")}}</h2>
	<br/><br/>
	<p>{{ $t("privacy.textTwoOne")}}</p>
	<p>{{ $t("privacy.textTwoTwo")}}</p>
	<p>{{ $t("privacy.textTwoTree")}}</p>
	<p>{{ $t("privacy.textTwoFour")}}</p>
	<br/><br/>
	<h2 class="text-primar-400 text-3xl lg:text-4xl lg:leading-10 font-extrabold">{{ $t("privacy.titleTree")}}</h2>
	<br/><br/>
	<p>{{ $t("privacy.textTreeOne")}}</p>
	<p>{{ $t("privacy.textTreeTwo")}}</p>
	<br/><br/>
	<h2 class="text-primar-400 text-3xl lg:text-4xl lg:leading-10 font-extrabold">{{ $t("privacy.titleFour")}}</h2>
	<br/><br/>
	<p>{{ $t("privacy.textFourOne")}}</p>
	<br/><br/>
	<h2 class="text-primar-400 text-3xl lg:text-4xl lg:leading-10 font-extrabold">{{ $t("privacy.titleFive")}}</h2>
	<br/><br/>
	<p>{{ $t("privacy.textFiveOne")}}</p>
	<br/><br/>
	<h2 class="text-primar-400 text-3xl lg:text-4xl lg:leading-10 font-extrabold">{{ $t("privacy.titleSix")}}</h2>
	<br/><br/>
	<p>{{ $t("privacy.textSixOne")}}</p>
	<p>{{ $t("privacy.textSixTwo")}}</p>
    </div>
  </main>
</template>
<script>

export default {
  created() {
    
  }
}

</script>